const NoAccess = () => {
  return (
    <div className="h-full flex flex-col items-center justify-center text-center px-6">
      <h1 className="text-2xl font-semibold text-white mb-2">
        Access Restricted
      </h1>
      <p className="text-slate-400 max-w-md">
        You don’t have permission to access any sections of this dashboard.
        Please contact your administrator if you believe this is a mistake.
      </p>
    </div>
  );
};

export default NoAccess;
